// Shared Monaco ESM worker configuration.
// Consolidates worker setup so multiple editor components don't overwrite each other.
//
// Workers are pre-bundled by scripts/bundle-monaco-workers.mjs into
// public/workers/ as self-contained IIFE scripts. This is necessary
// because turbopack's production build does not bundle worker dependencies —
// it copies ESM source files as static assets with unresolvable imports.

let initialized = false

/**
 * Registers a single MonacoEnvironment.getWorker that handles all known
 * language worker types. Safe to call from multiple editor components —
 * only the first call takes effect.
 */
export function initMonacoWorkers(): void {
    if (initialized) return
    initialized = true

    ;(globalThis as Record<string, unknown>).MonacoEnvironment = {
        getWorker(_workerId: string, label: string): Worker {
            let workerFile: string
            switch (label) {
                case 'json':
                    workerFile = 'json.worker.js'
                    break
                case 'yaml':
                    workerFile = 'yaml.worker.js'
                    break
                case 'typescript':
                case 'javascript':
                    workerFile = 'ts.worker.js'
                    break
                default:
                    workerFile = 'editor.worker.js'
                    break
            }
            return new Worker(`/workers/${workerFile}`)
        },
    }
}
